export * from './src/academy-certifications-v1-account-certification-account-certifications.schemas.js';
